import React from "react";
import ReactGA from "react-ga";
import styles from "./download.module.scss";
import { ICON_DOWNLOAD } from "../../config/constants";

ReactGA.initialize("UA-11963560-5");

export default function Download(props) {
    const handleDownload = () => {
        ReactGA.event({
            category: "SCIKNOW: explore",
            action: "download",
        });
    };

    return (
        <a
            className={styles.buttonDownload}
            href={"https://gbrmpa-science-knowledge.netlify.app/gbrmpa-needs-data-v1.xlsx"}
            download={"gbrmpa-needs-data-v1.xlsx"}
            onClick={handleDownload}
        >
            <span className={styles.downloadIcon}>{ICON_DOWNLOAD}</span>
            Download all opportunities
        </a>
    );
}
